// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file plataforma_terceros_fincas.proto (package sextante.plataforma.terceros.fincas.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plataforma_terceros_fincas.proto.
 */
export const file_plataforma_terceros_fincas: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Finca de la que se pide la ficha y su cliente dueno.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.GetFichaFincaRequest
 */
export type GetFichaFincaRequest = Message<"sextante.plataforma.terceros.fincas.v1.GetFichaFincaRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * Cliente dueño: define el nombre de la finca (cada dueño la nombra) y "plataforma activa".
   *
   * @generated from field: string cliente_id = 2;
   */
  clienteId: string;
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.GetFichaFincaRequest.
 * Use `create(GetFichaFincaRequestSchema)` to create a new message.
 */
export const GetFichaFincaRequestSchema: GenMessage<GetFichaFincaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 0);

/**
 * Ficha de la finca con sus lotes.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.FichaFincaPlataformaResponse
 */
export type FichaFincaPlataformaResponse = Message<"sextante.plataforma.terceros.fincas.v1.FichaFincaPlataformaResponse"> & {
  /**
   * @generated from field: sextante.plataforma.terceros.fincas.v1.FincaFichaPlataformaItem finca = 1;
   */
  finca?: FincaFichaPlataformaItem | undefined;

  /**
   * No eliminados, por nombre.
   *
   * @generated from field: repeated sextante.plataforma.terceros.fincas.v1.LoteFichaPlataformaItem lotes = 2;
   */
  lotes: LoteFichaPlataformaItem[];
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.FichaFincaPlataformaResponse.
 * Use `create(FichaFincaPlataformaResponseSchema)` to create a new message.
 */
export const FichaFincaPlataformaResponseSchema: GenMessage<FichaFincaPlataformaResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 1);

/**
 * Finca de la ficha, con geometrias, ortomosaico y conteo.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.FincaFichaPlataformaItem
 */
export type FincaFichaPlataformaItem = Message<"sextante.plataforma.terceros.fincas.v1.FincaFichaPlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre_finca = 2;
   */
  nombreFinca: string;

  /**
   * @generated from field: optional string municipio_nombre = 3;
   */
  municipioNombre?: string | undefined;

  /**
   * @generated from field: optional string departamento_nombre = 4;
   */
  departamentoNombre?: string | undefined;

  /**
   * @generated from field: optional string departamento_region_nombre = 5;
   */
  departamentoRegionNombre?: string | undefined;

  /**
   * @generated from field: double hectareas_finca = 6;
   */
  hectareasFinca: number;

  /**
   * @generated from field: double hectareas_productivas = 7;
   */
  hectareasProductivas: number;

  /**
   * 0 Agricultura, 1 Ganaderia.
   *
   * @generated from field: int32 tipo_finca = 8;
   */
  tipoFinca: number;

  /**
   * Licencia del cliente vigente (vencimiento futuro).
   *
   * @generated from field: bool plataforma_activa = 9;
   */
  plataformaActiva: boolean;

  /**
   * Cultivos distintos de sus lotes, ordenados.
   *
   * @generated from field: repeated string cultivos = 10;
   */
  cultivos: string[];

  /**
   * URL del ZIP del ortomosaico subido, si hay.
   *
   * @generated from field: optional string zip_ortomosaico = 11;
   */
  zipOrtomosaico?: string | undefined;

  /**
   * URL de los tiles del ortomosaico publicado, si hay.
   *
   * @generated from field: optional string uri_ortomosaico = 12;
   */
  uriOrtomosaico?: string | undefined;

  /**
   * 0 sin gestionar, 1 pendiente, 2 listo, 3 error.
   *
   * @generated from field: int32 ortomosaico_estado = 13;
   */
  ortomosaicoEstado: number;

  /**
   * Motivo del error del ortomosaico, si fallo.
   *
   * @generated from field: optional string ortomosaico_error = 14;
   */
  ortomosaicoError?: string | undefined;

  /**
   * AOI (Polygon) en WKB.
   *
   * @generated from field: optional bytes satelite_area_geografica = 15;
   */
  sateliteAreaGeografica?: Uint8Array | undefined;

  /**
   * Conteo (MultiPoint, un punto por arbol) en WKB.
   *
   * @generated from field: optional bytes conteo_multi_point = 16;
   */
  conteoMultiPoint?: Uint8Array | undefined;
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.FincaFichaPlataformaItem.
 * Use `create(FincaFichaPlataformaItemSchema)` to create a new message.
 */
export const FincaFichaPlataformaItemSchema: GenMessage<FincaFichaPlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 2);

/**
 * Lote de la ficha de la finca.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.LoteFichaPlataformaItem
 */
export type LoteFichaPlataformaItem = Message<"sextante.plataforma.terceros.fincas.v1.LoteFichaPlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre_lote = 2;
   */
  nombreLote: string;

  /**
   * @generated from field: double area_hectareas = 3;
   */
  areaHectareas: number;

  /**
   * @generated from field: double area_cuadras = 4;
   */
  areaCuadras: number;

  /**
   * true si el lote cuenta para las hectareas productivas de la finca.
   *
   * @generated from field: bool is_area_productiva = 5;
   */
  isAreaProductiva: boolean;

  /**
   * @generated from field: optional string cultivo_nombre = 6;
   */
  cultivoNombre?: string | undefined;

  /**
   * Etiqueta del tipo de monitoreo del cultivo ("Cafe", "Citricos"...); ausente = sin monitoreo.
   *
   * @generated from field: optional string tipo_monitoreo = 7;
   */
  tipoMonitoreo?: string | undefined;

  /**
   * Poligono del lote en WKB.
   *
   * @generated from field: bytes area_geografica = 8;
   */
  areaGeografica: Uint8Array;
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.LoteFichaPlataformaItem.
 * Use `create(LoteFichaPlataformaItemSchema)` to create a new message.
 */
export const LoteFichaPlataformaItemSchema: GenMessage<LoteFichaPlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 3);

/**
 * Cliente del que se piden las fincas.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.ListFincasByClienteRequest
 */
export type ListFincasByClienteRequest = Message<"sextante.plataforma.terceros.fincas.v1.ListFincasByClienteRequest"> & {
  /**
   * @generated from field: string cliente_id = 1;
   */
  clienteId: string;
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.ListFincasByClienteRequest.
 * Use `create(ListFincasByClienteRequestSchema)` to create a new message.
 */
export const ListFincasByClienteRequestSchema: GenMessage<ListFincasByClienteRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 4);

/**
 * Fincas activas del cliente, por nombre.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.ListFincasByClientePlataformaResponse
 */
export type ListFincasByClientePlataformaResponse = Message<"sextante.plataforma.terceros.fincas.v1.ListFincasByClientePlataformaResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.terceros.fincas.v1.FincaListaPlataformaItem items = 1;
   */
  items: FincaListaPlataformaItem[];
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.ListFincasByClientePlataformaResponse.
 * Use `create(ListFincasByClientePlataformaResponseSchema)` to create a new message.
 */
export const ListFincasByClientePlataformaResponseSchema: GenMessage<ListFincasByClientePlataformaResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 5);

/**
 * Lo que usan la ficha comercial y la cotizacion de Pipeline y el wizard de Proyectos.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.FincaListaPlataformaItem
 */
export type FincaListaPlataformaItem = Message<"sextante.plataforma.terceros.fincas.v1.FincaListaPlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre_finca = 2;
   */
  nombreFinca: string;

  /**
   * 0 = Agricultura, 1 = Ganaderia.
   *
   * @generated from field: int32 tipo_finca = 3;
   */
  tipoFinca: number;

  /**
   * @generated from field: optional string municipio_nombre = 4;
   */
  municipioNombre?: string | undefined;

  /**
   * @generated from field: double hectareas_finca = 5;
   */
  hectareasFinca: number;
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.FincaListaPlataformaItem.
 * Use `create(FincaListaPlataformaItemSchema)` to create a new message.
 */
export const FincaListaPlataformaItemSchema: GenMessage<FincaListaPlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 6);

/**
 * Finca a crear o editar desde el formulario.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.GuardarFincaPlataformaRequest
 */
export type GuardarFincaPlataformaRequest = Message<"sextante.plataforma.terceros.fincas.v1.GuardarFincaPlataformaRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string cliente_id = 2;
   */
  clienteId: string;

  /**
   * @generated from field: string nombre = 3;
   */
  nombre: string;

  /**
   * Los opcionales ausentes conservan el valor actual (en un alta, el valor por defecto).
   *
   * @generated from field: optional int32 tipo = 4;
   */
  tipo?: number | undefined;

  /**
   * @generated from field: optional double hectareas_finca = 5;
   */
  hectareasFinca?: number | undefined;

  /**
   * @generated from field: optional double hectareas_productivas = 6;
   */
  hectareasProductivas?: number | undefined;

  /**
   * @generated from field: optional string departamento_id = 7;
   */
  departamentoId?: string | undefined;

  /**
   * @generated from field: optional string municipio_id = 8;
   */
  municipioId?: string | undefined;

  /**
   * @generated from field: optional string departamento_region_id = 9;
   */
  departamentoRegionId?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.GuardarFincaPlataformaRequest.
 * Use `create(GuardarFincaPlataformaRequestSchema)` to create a new message.
 */
export const GuardarFincaPlataformaRequestSchema: GenMessage<GuardarFincaPlataformaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 7);

/**
 * Lo que pinta la card de finca en el detalle del cliente.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.FincaGuardadaPlataformaItem
 */
export type FincaGuardadaPlataformaItem = Message<"sextante.plataforma.terceros.fincas.v1.FincaGuardadaPlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre_finca = 2;
   */
  nombreFinca: string;

  /**
   * @generated from field: optional string municipio_nombre = 3;
   */
  municipioNombre?: string | undefined;

  /**
   * @generated from field: optional string departamento_nombre = 4;
   */
  departamentoNombre?: string | undefined;

  /**
   * @generated from field: double hectareas_finca = 5;
   */
  hectareasFinca: number;

  /**
   * @generated from field: repeated string cultivos = 6;
   */
  cultivos: string[];
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.FincaGuardadaPlataformaItem.
 * Use `create(FincaGuardadaPlataformaItemSchema)` to create a new message.
 */
export const FincaGuardadaPlataformaItemSchema: GenMessage<FincaGuardadaPlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 8);

/**
 * Relacion cliente-finca a dar de baja.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.EliminarRelacionFincaRequest
 */
export type EliminarRelacionFincaRequest = Message<"sextante.plataforma.terceros.fincas.v1.EliminarRelacionFincaRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * @generated from field: string cliente_id = 2;
   */
  clienteId: string;
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.EliminarRelacionFincaRequest.
 * Use `create(EliminarRelacionFincaRequestSchema)` to create a new message.
 */
export const EliminarRelacionFincaRequestSchema: GenMessage<EliminarRelacionFincaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 9);

/**
 * Finca que se da de baja (sin clientes y sin datos).
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.EliminarFincaRequest
 */
export type EliminarFincaRequest = Message<"sextante.plataforma.terceros.fincas.v1.EliminarFincaRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.EliminarFincaRequest.
 * Use `create(EliminarFincaRequestSchema)` to create a new message.
 */
export const EliminarFincaRequestSchema: GenMessage<EliminarFincaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 10);

/**
 * Cliente al que se asigna la finca, ademas de los dueños que ya tiene.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.AsignarClienteFincaRequest
 */
export type AsignarClienteFincaRequest = Message<"sextante.plataforma.terceros.fincas.v1.AsignarClienteFincaRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * @generated from field: string cliente_id = 2;
   */
  clienteId: string;

  /**
   * Nombre que ese cliente le da a la finca: unico entre sus fincas.
   *
   * @generated from field: string nombre = 3;
   */
  nombre: string;
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.AsignarClienteFincaRequest.
 * Use `create(AsignarClienteFincaRequestSchema)` to create a new message.
 */
export const AsignarClienteFincaRequestSchema: GenMessage<AsignarClienteFincaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 11);

/**
 * Las cargas y la baja no devuelven datos: la web recarga la ficha.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.FincaAccionResponse
 */
export type FincaAccionResponse = Message<"sextante.plataforma.terceros.fincas.v1.FincaAccionResponse"> & {
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.FincaAccionResponse.
 * Use `create(FincaAccionResponseSchema)` to create a new message.
 */
export const FincaAccionResponseSchema: GenMessage<FincaAccionResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 12);

/**
 * Archivo ya subido a Storage para cargar en una finca: AOI, lotes, conteo u ortomosaico.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.GuardarArchivoFincaRequest
 */
export type GuardarArchivoFincaRequest = Message<"sextante.plataforma.terceros.fincas.v1.GuardarArchivoFincaRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * URL permanente del blob ya subido con el SAS de GetSasSubida.
   *
   * @generated from field: string blob_url = 2;
   */
  blobUrl: string;

  /**
   * Cliente desde cuya ficha se carga: el mensaje de solape distingue si la finca en conflicto es suya.
   *
   * @generated from field: optional string cliente_id = 3;
   */
  clienteId?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.GuardarArchivoFincaRequest.
 * Use `create(GuardarArchivoFincaRequestSchema)` to create a new message.
 */
export const GuardarArchivoFincaRequestSchema: GenMessage<GuardarArchivoFincaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 13);

/**
 * Filtro opcional por cliente.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.ListOrtomosaicosPendientesRequest
 */
export type ListOrtomosaicosPendientesRequest = Message<"sextante.plataforma.terceros.fincas.v1.ListOrtomosaicosPendientesRequest"> & {
  /**
   * Ausente = toda la organizacion.
   *
   * @generated from field: optional string cliente_id = 1;
   */
  clienteId?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.ListOrtomosaicosPendientesRequest.
 * Use `create(ListOrtomosaicosPendientesRequestSchema)` to create a new message.
 */
export const ListOrtomosaicosPendientesRequestSchema: GenMessage<ListOrtomosaicosPendientesRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 14);

/**
 * Fincas con ortomosaico pendiente o con error.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.ListOrtomosaicosPendientesResponse
 */
export type ListOrtomosaicosPendientesResponse = Message<"sextante.plataforma.terceros.fincas.v1.ListOrtomosaicosPendientesResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.terceros.fincas.v1.OrtomosaicoPendientePlataformaItem items = 1;
   */
  items: OrtomosaicoPendientePlataformaItem[];
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.ListOrtomosaicosPendientesResponse.
 * Use `create(ListOrtomosaicosPendientesResponseSchema)` to create a new message.
 */
export const ListOrtomosaicosPendientesResponseSchema: GenMessage<ListOrtomosaicosPendientesResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 15);

/**
 * Finca con su estado de ortomosaico.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.OrtomosaicoPendientePlataformaItem
 */
export type OrtomosaicoPendientePlataformaItem = Message<"sextante.plataforma.terceros.fincas.v1.OrtomosaicoPendientePlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre_finca = 2;
   */
  nombreFinca: string;

  /**
   * 1 pendiente, 3 error.
   *
   * @generated from field: int32 ortomosaico_estado = 3;
   */
  ortomosaicoEstado: number;

  /**
   * @generated from field: optional string ortomosaico_error = 4;
   */
  ortomosaicoError?: string | undefined;

  /**
   * Unix ms: el vigilante lo compara contra su watermark.
   *
   * @generated from field: int64 ultima_actualizacion = 5;
   */
  ultimaActualizacion: bigint;
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.OrtomosaicoPendientePlataformaItem.
 * Use `create(OrtomosaicoPendientePlataformaItemSchema)` to create a new message.
 */
export const OrtomosaicoPendientePlataformaItemSchema: GenMessage<OrtomosaicoPendientePlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 16);

/**
 * Archivo a subir.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.GetSasSubidaRequest
 */
export type GetSasSubidaRequest = Message<"sextante.plataforma.terceros.fincas.v1.GetSasSubidaRequest"> & {
  /**
   * Nombre del archivo. Se usa solo el nombre, sin carpetas.
   *
   * @generated from field: string file_name = 1;
   */
  fileName: string;
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.GetSasSubidaRequest.
 * Use `create(GetSasSubidaRequestSchema)` to create a new message.
 */
export const GetSasSubidaRequestSchema: GenMessage<GetSasSubidaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 17);

/**
 * Donde subir el archivo y donde va a quedar.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.SasSubidaResponse
 */
export type SasSubidaResponse = Message<"sextante.plataforma.terceros.fincas.v1.SasSubidaResponse"> & {
  /**
   * URL firmada para subir el archivo con un PUT.
   *
   * @generated from field: string sas_url = 1;
   */
  sasUrl: string;

  /**
   * URL del archivo ya subido, sin firma: es la que se manda en blob_url.
   *
   * @generated from field: string blob_url = 2;
   */
  blobUrl: string;
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.SasSubidaResponse.
 * Use `create(SasSubidaResponseSchema)` to create a new message.
 */
export const SasSubidaResponseSchema: GenMessage<SasSubidaResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 18);

/**
 * Sin parametros.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.GetSasLecturaTilesRequest
 */
export type GetSasLecturaTilesRequest = Message<"sextante.plataforma.terceros.fincas.v1.GetSasLecturaTilesRequest"> & {
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.GetSasLecturaTilesRequest.
 * Use `create(GetSasLecturaTilesRequestSchema)` to create a new message.
 */
export const GetSasLecturaTilesRequestSchema: GenMessage<GetSasLecturaTilesRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 19);

/**
 * Token de lectura de Storage y su vencimiento.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.SasLecturaTilesResponse
 */
export type SasLecturaTilesResponse = Message<"sextante.plataforma.terceros.fincas.v1.SasLecturaTilesResponse"> & {
  /**
   * Token SAS que se agrega a las URL de los tiles.
   *
   * @generated from field: string sas_token = 1;
   */
  sasToken: string;

  /**
   * Unix ms.
   *
   * @generated from field: int64 expires_on = 2;
   */
  expiresOn: bigint;
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.SasLecturaTilesResponse.
 * Use `create(SasLecturaTilesResponseSchema)` to create a new message.
 */
export const SasLecturaTilesResponseSchema: GenMessage<SasLecturaTilesResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 20);

/**
 * Sin parametros.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.ListFincasMapaRequest
 */
export type ListFincasMapaRequest = Message<"sextante.plataforma.terceros.fincas.v1.ListFincasMapaRequest"> & {
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.ListFincasMapaRequest.
 * Use `create(ListFincasMapaRequestSchema)` to create a new message.
 */
export const ListFincasMapaRequestSchema: GenMessage<ListFincasMapaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 21);

/**
 * Fincas del mapa global.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.ListFincasMapaResponse
 */
export type ListFincasMapaResponse = Message<"sextante.plataforma.terceros.fincas.v1.ListFincasMapaResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.terceros.fincas.v1.FincaMapaItem items = 1;
   */
  items: FincaMapaItem[];
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.ListFincasMapaResponse.
 * Use `create(ListFincasMapaResponseSchema)` to create a new message.
 */
export const ListFincasMapaResponseSchema: GenMessage<ListFincasMapaResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 22);

/**
 * Finca en el mapa global.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.FincaMapaItem
 */
export type FincaMapaItem = Message<"sextante.plataforma.terceros.fincas.v1.FincaMapaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Ubicacion de la finca, o el centroide del AOI si no tiene.
   *
   * @generated from field: double latitud = 2;
   */
  latitud: number;

  /**
   * @generated from field: double longitud = 3;
   */
  longitud: number;

  /**
   * AOI simplificado (~2 m) en WKB 2D; ausente si la finca no tiene AOI.
   *
   * @generated from field: optional bytes aoi_wkb = 4;
   */
  aoiWkb?: Uint8Array | undefined;

  /**
   * Clientes dueños (relacion activa), por nombre. Vacio = finca sin cliente.
   *
   * @generated from field: repeated sextante.plataforma.terceros.fincas.v1.DuenoFincaMapaItem duenos = 5;
   */
  duenos: DuenoFincaMapaItem[];

  /**
   * Solo en fincas sin cliente: el nombre de su ultima relacion (dada de baja), para mostrarla y prellenar la
   * asignacion. Ausente si nunca tuvo uno.
   *
   * @generated from field: optional string nombre_ultimo = 6;
   */
  nombreUltimo?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.FincaMapaItem.
 * Use `create(FincaMapaItemSchema)` to create a new message.
 */
export const FincaMapaItemSchema: GenMessage<FincaMapaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 23);

/**
 * Un dueño de la finca: el cliente y el nombre que ese cliente le da a la finca.
 *
 * @generated from message sextante.plataforma.terceros.fincas.v1.DuenoFincaMapaItem
 */
export type DuenoFincaMapaItem = Message<"sextante.plataforma.terceros.fincas.v1.DuenoFincaMapaItem"> & {
  /**
   * @generated from field: string cliente_id = 1;
   */
  clienteId: string;

  /**
   * @generated from field: string cliente_nombre = 2;
   */
  clienteNombre: string;

  /**
   * @generated from field: string nombre_finca = 3;
   */
  nombreFinca: string;
};

/**
 * Describes the message sextante.plataforma.terceros.fincas.v1.DuenoFincaMapaItem.
 * Use `create(DuenoFincaMapaItemSchema)` to create a new message.
 */
export const DuenoFincaMapaItemSchema: GenMessage<DuenoFincaMapaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_fincas, 24);

/**
 * Fincas de la app Plataforma (menu Clientes: ficha de finca, form, cargas GIS; lo reusan Pipeline y el
 * wizard de Proyectos). Migracion a gRPC-Web con logica propia (ver CLAUDE.md); las reglas de nombre,
 * solape de AOI y lotes salen de Api/Grpc/Comun/ReglasFinca (compartidas con el wizard de Cliente).
 * Geometrias en WKB (bytes, ST_AsBinary sin SRID). Solo los campos que usa la web. Requiere sesion de
 * Plataforma.
 *
 * @generated from service sextante.plataforma.terceros.fincas.v1.FincasPlataformaService
 */
export const FincasPlataformaService: GenService<{
  /**
   * Ficha: finca (con geometrias, estado de ortomosaico y conteo) + lotes. NotFound si la finca no existe,
   * esta eliminada o el cliente no es dueño activo.
   *
   * @generated from rpc sextante.plataforma.terceros.fincas.v1.FincasPlataformaService.GetFicha
   */
  getFicha: {
    methodKind: "unary";
    input: typeof GetFichaFincaRequestSchema;
    output: typeof FichaFincaPlataformaResponseSchema;
  },
  /**
   * Fincas activas del cliente (resumen para Pipeline y el wizard de Proyectos), por nombre.
   *
   * @generated from rpc sextante.plataforma.terceros.fincas.v1.FincasPlataformaService.ListByCliente
   */
  listByCliente: {
    methodKind: "unary";
    input: typeof ListFincasByClienteRequestSchema;
    output: typeof ListFincasByClientePlataformaResponseSchema;
  },
  /**
   * Alta (sin id) o edicion (con id) de finca desde el form. Conserva lo que no viene. Nombre unico por
   * cliente (ReglasFinca). Devuelve el resumen que pinta la card.
   *
   * @generated from rpc sextante.plataforma.terceros.fincas.v1.FincasPlataformaService.Guardar
   */
  guardar: {
    methodKind: "unary";
    input: typeof GuardarFincaPlataformaRequestSchema;
    output: typeof FincaGuardadaPlataformaItemSchema;
  },
  /**
   * Da de baja la relacion cliente-finca (no la finca). Idempotente.
   *
   * @generated from rpc sextante.plataforma.terceros.fincas.v1.FincasPlataformaService.EliminarRelacion
   */
  eliminarRelacion: {
    methodKind: "unary";
    input: typeof EliminarRelacionFincaRequestSchema;
    output: typeof FincaAccionResponseSchema;
  },
  /**
   * Da de baja la finca (desde el mapa global). Solo si no tiene ningun cliente activo y no tiene datos
   * (monitoreo, ganaderia, fertilizacion, aplicaciones, proyectos, tareas del GPS); si no, InvalidArgument con el
   * motivo. Descarta los registros del asistente en curso sobre ella y deja su area libre. Idempotente.
   *
   * @generated from rpc sextante.plataforma.terceros.fincas.v1.FincasPlataformaService.EliminarFinca
   */
  eliminarFinca: {
    methodKind: "unary";
    input: typeof EliminarFincaRequestSchema;
    output: typeof FincaAccionResponseSchema;
  },
  /**
   * Asigna la finca a un cliente mas: relacion nueva con el nombre que ese cliente le da. La finca no se
   * copia, los dueños comparten AOI, lotes y datos. Error si ya es dueño o si el nombre se repite en sus fincas.
   *
   * @generated from rpc sextante.plataforma.terceros.fincas.v1.FincasPlataformaService.AsignarCliente
   */
  asignarCliente: {
    methodKind: "unary";
    input: typeof AsignarClienteFincaRequestSchema;
    output: typeof DuenoFincaMapaItemSchema;
  },
  /**
   * Reemplaza el AOI con el poligono de un KML/KMZ/ZIP ya subido; recalcula ubicacion, division
   * administrativa y hectareas, y re-registra en satelite. Rechaza si los lotes ya tienen datos, si se
   * solapa con otra finca o si deja lotes afuera.
   *
   * @generated from rpc sextante.plataforma.terceros.fincas.v1.FincasPlataformaService.GuardarAoi
   */
  guardarAoi: {
    methodKind: "unary";
    input: typeof GuardarArchivoFincaRequestSchema;
    output: typeof FincaAccionResponseSchema;
  },
  /**
   * Reemplaza los lotes con los del archivo (reconcilia por nombre normalizado). Requiere AOI.
   *
   * @generated from rpc sextante.plataforma.terceros.fincas.v1.FincasPlataformaService.GuardarLotes
   */
  guardarLotes: {
    methodKind: "unary";
    input: typeof GuardarArchivoFincaRequestSchema;
    output: typeof FincaAccionResponseSchema;
  },
  /**
   * Carga el conteo (un punto por arbol) desde un KML ya subido y encola los tiles del conteo.
   *
   * @generated from rpc sextante.plataforma.terceros.fincas.v1.FincasPlataformaService.GuardarConteo
   */
  guardarConteo: {
    methodKind: "unary";
    input: typeof GuardarArchivoFincaRequestSchema;
    output: typeof FincaAccionResponseSchema;
  },
  /**
   * Asocia el ZIP del ortomosaico y encola su publicacion (descarta el publicado anterior).
   *
   * @generated from rpc sextante.plataforma.terceros.fincas.v1.FincasPlataformaService.GuardarOrtomosaico
   */
  guardarOrtomosaico: {
    methodKind: "unary";
    input: typeof GuardarArchivoFincaRequestSchema;
    output: typeof FincaAccionResponseSchema;
  },
  /**
   * Fincas con ortomosaico pendiente o con error, de la mas reciente a la mas antigua (sin paginar).
   *
   * @generated from rpc sextante.plataforma.terceros.fincas.v1.FincasPlataformaService.ListOrtomosaicosPendientes
   */
  listOrtomosaicosPendientes: {
    methodKind: "unary";
    input: typeof ListOrtomosaicosPendientesRequestSchema;
    output: typeof ListOrtomosaicosPendientesResponseSchema;
  },
  /**
   * Mapa global: fincas no eliminadas con ubicacion o AOI, con su AOI simplificado y sus dueños activos;
   * incluye las que no tienen ningun cliente (para poder asignarlas). Un promotor, solo las de su cartera.
   *
   * @generated from rpc sextante.plataforma.terceros.fincas.v1.FincasPlataformaService.ListFincasMapa
   */
  listFincasMapa: {
    methodKind: "unary";
    input: typeof ListFincasMapaRequestSchema;
    output: typeof ListFincasMapaResponseSchema;
  },
  /**
   * SAS de subida (PUT directo a Azure) para un archivo nuevo en archivos/{guid}/{nombre}.
   *
   * @generated from rpc sextante.plataforma.terceros.fincas.v1.FincasPlataformaService.GetSasSubida
   */
  getSasSubida: {
    methodKind: "unary";
    input: typeof GetSasSubidaRequestSchema;
    output: typeof SasSubidaResponseSchema;
  },
  /**
   * SAS de lectura de cuenta (24 h) para los tiles de ortomosaico/conteo del mapa de la finca.
   *
   * @generated from rpc sextante.plataforma.terceros.fincas.v1.FincasPlataformaService.GetSasLecturaTiles
   */
  getSasLecturaTiles: {
    methodKind: "unary";
    input: typeof GetSasLecturaTilesRequestSchema;
    output: typeof SasLecturaTilesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_plataforma_terceros_fincas, 0);

